import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, Inject, AfterViewInit, DOCUMENT } from "@angular/core";
import { ProgramService } from "../../../../../../services/aws/program/program.service";
import { Observable, Subject } from "rxjs";
import { map, take, takeUntil } from "rxjs/operators";
import { IMissedInfo, IDeletedInfo, IMissedPrePostInfo } from "../../../../../../models/ITimeMissedInfo";
import { IParticipants, IFacilitators } from "../../../../../../models/IClassRoster";
import moment from 'moment';
import { ClassRosterService } from "src/app/services/aws/class/class-roster.service";
import { AuthenticationService } from "../../../../../../services/authentication/authentication.service";
import { IConfirmation } from "../../../../../../models/IConfirmation";
import { ReportService } from "../../../../../../services/aws/report/report.service";
import { Router } from '@angular/router';
import { IErrorMessage } from 'src/app/widgets/error-message/error-message.interface';
import { API_USER_DEFINED_MESSAGE } from 'src/app/widgets/error-message/error-message.const';
import { TimeDiff } from 'src/app/widgets/pipes/timeDiff.pipe';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from "@angular/material/snack-bar";
import { ClassDetailComponent } from "../classdetail.component";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";

import { ConfirmDialogComponent } from "src/app/widgets/confirm-dialog/confirm-dialog.component";
import {
    getTimeRangeValidationWithCompleteness,
    hasCompleteTimePair
} from "src/app/utils/validate-time-range";

@Component(
    {
    selector: "class-roster",
    templateUrl: "./class-roster.component.html",
    styles: [],
    providers: [TimeDiff],
    standalone: false
}
)
export class ClassRosterComponent implements OnInit, OnDestroy,AfterViewInit {
    @Input() roster: any;
    @Input() programId: any;
    @Input() classId: any;
    @Input() reportName: any;
    @Input() classDate: any;
    @Input() classEndDate: any;
    @Input() facilitatorAttendance: boolean;
    @Output() editedIndexEvent = new EventEmitter<any>();
    @Output() isAnyFormOpen = new EventEmitter<any>();

    protected destroy$ = new Subject();
    public facilitatorsErrorMessage: IErrorMessage = {};
    public participantsErrorMessage: IErrorMessage = {};
    facilitators: IFacilitators[];
    _facilitators: IFacilitators[];
    participants: IParticipants[];
    _participants: IParticipants[];
    show: boolean = true;
    showLoading = false;
    isDesc: boolean = false;
    column: string = 'fullName';
    direction: number;
    isNameAsc: boolean = false;
    isEmailAsc: boolean = false;
    isfacilitationAsc: boolean = false;
    isParticipationAsc: boolean = false;
    isParticipantNameAsc: boolean = false;
    isParticipantEmailAsc: boolean = false;
    selectedIndex: number;
    participantSelectedIndex: number;
    selectedPickerId: number;
    selectedType: string;
    selectedTarget: string;
    missedInfo: IMissedInfo = {} as IMissedInfo;
    arrMissedInfo: IMissedInfo[] = [];
    deletedInfo: IDeletedInfo = {} as IDeletedInfo;
    addedParticipantsInfo: any[] = [] as any[];
    addedFacilitatorsInfo: any[] = [] as any[];
    addedFacilitation: any[] = [] as any[];
    addedParticipation: any[] = [];
    newAddedDetails: IMissedInfo = {} as IMissedInfo;
    isAdded = false;
    isDeleted = false;
    listText = '';
    getNewUpdatedMissedTime: any;
    addNewReasonItems: string;
    isSuccess = false;
    isShowSave = false;
    protected updatedDetailCache: IMissedPrePostInfo[] = [];
    updatedDetails: IMissedPrePostInfo = {} as IMissedPrePostInfo;
    selectedBox;
    selectedParticipantBox;
    reasonBox;
    saveReason;
    reasonItems: string;
    items: string;
    successMsg;
    cancelBtn;
    undoBtn;
    keepEditing;
    search: any;
    isParticipantDesc: boolean = false;
    participantColumn: string = 'fullName';
    participantDirection: number;
    emaildetail$: any;
    email: any;
    facilitatorIndex: any;
    facilitationSelectedIndex: number;
    participatiopnSelectedIndex: number;
    enableCheckbox = true;
    isConfirmed = false;
    isFacilitatorOver: string;
    doConfirm = false;
    public confirmationDataErrorMessage: IErrorMessage = {};
    confirmationData;
    personDetail$: Observable<any>;
    showReport = false;
    commentBoxType: string;
    cancelModel = false;
    cancelType: string;
    showReason: boolean = false;
    classStatus: number;
    horizontalPosition: MatSnackBarHorizontalPosition = 'right';
    verticalPosition: MatSnackBarVerticalPosition = 'top';
    editStatusMap: { [key: number]: boolean } = {};
    /** Shown under active time range row when end ≤ start. */
    timeRangeInlineError: string | null = null;
    /** Facilitator-table row index for which {@link timeRangeInlineError} applies. */
    timeRangeErrorFacilitatorRow: number | null = null;
    /** Participant-table row index for which {@link timeRangeInlineError} applies. */
    timeRangeErrorParticipantRow: number | null = null;

    constructor(protected programService: ProgramService,
        protected classRosterService: ClassRosterService,
        protected auth: AuthenticationService,
        protected reportService: ReportService,
        protected timeDiff: TimeDiff,
        protected router: Router,
        protected snackBar: MatSnackBar,
        protected classDetailComponent: ClassDetailComponent,
        protected dialogRef: MatDialogRef<ClassRosterComponent>,
        @Inject(DOCUMENT) protected document: Document,
        protected dialog: MatDialog
    ) {
        this.participantDirection = 1;
        this.direction = 1;
        // this.addedFacilitation.checkInTime = 'Add Time';
        // this.addedFacilitation.checkOutTime = 'Add Time';
        // this.addedParticipation.checkInTime = 'Add Time';
        // this.addedParticipation.checkOutTime = 'Add Time';
        this.emaildetail$ = this.auth.getUserEmail();
    }

    ngAfterViewInit() {
        setTimeout(() => {
          const overlay = this.document.querySelector('.cdk-overlay-backdrop');
          if (overlay) {
            overlay.addEventListener('click', this.handleBackdropClick.bind(this));
          }
        });
      }
      handleBackdropClick() {
        const isAnyFormOpen = this.facilitators.some(f => f.isEdit) || this.participants.some(p => p.isEdit);
        if (isAnyFormOpen) {
            this.dialog.open(ConfirmDialogComponent, {
                data: {
                    title: "",
                    body: "Are you sure you want to exit and lose changes?",
                    buttonTextNo: "Keep Editing",
                    buttonTextYes: "Exit"
                },
                panelClass: 'notification-submit-dialog',
                disableClose:true
            }).afterClosed()
                .pipe(take(1))
                .subscribe(result => {
                    if (result) {
                        this.dialogRef.close();
                    }
                });
        }
        else {
            this.dialogRef.close();
        }
      }


    ngOnInit() {
        this.emaildetail$.pipe(take(1)).subscribe(x => {
            this.email = x;
            this.getConfirmation(this.programId, this.classId);
        });

        this.getRosterFacilitators(true);

        this.getRosterParticipants();


        if (moment(this.classDate).format('YYYY-MM-DD HH:mm') <= moment(new Date()).format('YYYY-MM-DD HH:mm')) {
            this.enableCheckbox = false;
        }
    }

    expandCollapse(type, values, index) {
        values.isEdit = !values.isEdit;
        this.editStatusMap[index] = values.isEdit ? true : undefined;
        this.checkIfAnyFormIsOpen(); // Dynamically set dialogRef.disableClose
        let selected = values.isEdit ? index : null;
        this.editedIndexEvent.emit(selected);
        this.resetFields();
    }

    expandAll(type) {
        if (type === 'facilitator') {
            this.facilitators.forEach((element) => {
                element.isEdit = true;
            });
        } else {
            this.participants.forEach((element) => {
                element.isEdit = true;
            });
        }
        this.checkIfAnyFormIsOpen();
        this.resetFields();
    }

    collapseAll(type) {
        if (type === 'facilitator') {
            this.facilitators.forEach((element) => {
                element.isEdit = false;
            });
        } else {
            this.participants.forEach((element) => {
                element.isEdit = false;
            });
        }

        this.checkIfAnyFormIsOpen();
        this.resetFields();
    }

    checkIfAnyFormIsOpen(): void {
        const isAnyFacilitatorOpen = this.facilitators?.some(f => f.isEdit);
        const isAnyParticipantOpen = this.participants?.some(p => p.isEdit);
        const isAnyOpen = isAnyFacilitatorOpen || isAnyParticipantOpen;
        this.dialogRef.disableClose = isAnyOpen;
        this.isAnyFormOpen.emit(isAnyOpen);
    }

    protected getNotifications() {
        if (this.classStatus == 1) {
            this.isFacilitatorOver = 'disable';
        } else if (this.classStatus == 2) {
            this.isFacilitatorOver = 'allow';
        } else if (this.classStatus == 3) {
            this.isFacilitatorOver = 'over';
        } else if (this.classStatus == 4) {
            this.isFacilitatorOver = 'isConfirmed';
        }
    }

    toggleRow(index, type) {
        if (type == 'participants') {
            this.selectedIndex = null;
            this.participantSelectedIndex = this.participantSelectedIndex == index ? null : index;
        } else {
            this.selectedIndex = this.selectedIndex == index ? null : index;
            this.participantSelectedIndex = null;
        }
        let selected = (this.participantSelectedIndex == index || this.selectedIndex == index) ? index : null;
        this.editedIndexEvent.emit(selected);
        // this.resetFields();
    }



    protected resetFields() {
        this.newAddedDetails = {} as IMissedInfo;
        this.newAddedDetails.checkInTime = undefined;
        this.newAddedDetails.checkOutTime = undefined;
        this.isAdded = false;
        this.isShowSave = false;
        this.setTimeRangeInlineError(null);
        this.addNewReasonItems = undefined;
        this.prepareAddParticipantsInfo(<IParticipants[]>this.participants);
        this.prepareAddFacilitatorsInfo(this.facilitators);
        // this.addedParticipantsInfo.checkInTime = 'Add Time';
        // this.addedParticipantsInfo.checkOutTime = 'Add Time';
        // this.addedFacilitation.checkInTime = 'Add Time';
        // this.addedFacilitation.checkOutTime = 'Add Time';
        // this.addedParticipation.checkInTime = 'Add Time';
        // this.addedParticipation.checkOutTime = 'Add Time';
        this.updatedDetailCache.splice(0, this.updatedDetailCache.length);
    }

    toggleComment(i, type) {
        if (type == 'participants') {
            this.selectedParticipantBox = i;
            this.commentBoxType = 'participants';
        } else {
            this.selectedBox = i;
            this.commentBoxType = 'facilitators';
        }
    }

    closeComment(i, type) {
        if (type == 'facilitators') {
            this.selectedBox = null;
        } else this.selectedParticipantBox = null;
    }

    toggleReason(i) {
        this.reasonBox = i;
        this.saveReason = i;
        this.cancelBtn = i;
        this.undoBtn = i;
        this.successMsg = null;
        this.keepEditing = null;
    }

    closeReason() {
        this.reasonBox = null;
        this.saveReason = null;
        this.cancelBtn = null;
        this.undoBtn = null;
    }

    SaveReasonBtn(i) {
        this.reasonBox = null;
        this.saveReason = null;
        this.cancelBtn = null;
        this.undoBtn = null;
        this.successMsg = i;
    }

    closeSuccess() {
        this.reasonBox = null;
        this.saveReason = null;
        this.cancelBtn = null;
        this.undoBtn = null;
        this.successMsg = null;
    }

    toggleCancel(i) {
        this.keepEditing = i;
    }


    toggleCancelClose() {
        this.keepEditing = null;
    }

    sort(property, type) {
        if (type == 'facilitator') {
            this.isDesc = !this.isDesc;
            this.column = property;
            this.direction = this.isDesc ? 1 : -1;
            switch (property) {
                case 'fullName':
                    this.isNameAsc = !this.isNameAsc;
                    break;
                case 'email':
                    this.isEmailAsc = !this.isEmailAsc;
                    break;
            }
        } else {
            this.isParticipantDesc = !this.isParticipantDesc;
            this.participantColumn = property;
            this.participantDirection = this.isParticipantDesc ? 1 : -1;
            switch (property) {
                case 'fullName':
                    this.isParticipantNameAsc = !this.isParticipantNameAsc;
                    break;
                case 'email':
                    this.isParticipantEmailAsc = !this.isParticipantEmailAsc;
                    break;
            }
        }
    }

    onFilter = () => {
        if (this.search) {
            let searchValue = this.search;
            this.roster = this.roster.detailList.participants.filter(item => (item.name.toLowerCase().includes(searchValue) || item.email.toLowerCase().includes(searchValue)));
        }
    };

    checkInStatus($event, participantId, data) {
        let participantCheckStatus = {
            participantId: participantId,
            checkIn: {
                status: $event.source ? $event.source.checked ? true : false : false,
                updatedBy: this.facilitatorIndex >= 0 ? "Facilitator" : 'Admin',
                createdBy: this.email
            }
        };
        participantCheckStatus.checkIn["recordId"] = data?.checkIn?.recordId;
        this.classRosterService.edit(this.programId, this.classId, ($event.source.id) ? "update" : "insert", "checkInStatus");
        this.classRosterService.update(participantCheckStatus);
        this.classRosterService.save().pipe(take(1)).subscribe(
            () => {
                this.getRosterFacilitators();
                this.getRosterParticipants();
                this.classDetailComponent.getDetail()
            });
    }

    handleFacilitationResponse($event, response, participantId, target) {
        const facilitationResponse: any = {
            participantId,
            facilitationResponse: {
                updatedBy: this.facilitatorIndex >= 0 ? "Facilitator" : 'Admin',
                createdBy: this.email
            }
        };
        if (target === "facilitation") {
            facilitationResponse.facilitationResponse.facilitationResponse = $event?.target?.value;
            facilitationResponse.facilitationResponse.participationResponse = response?.participationResponse;

        } else {
            facilitationResponse.facilitationResponse.participationResponse = $event?.target.value;
            facilitationResponse.facilitationResponse.facilitationResponse = response?.facilitationResponse;
        }
        if (response && response.id) {
            facilitationResponse.facilitationResponse["id"] = response.id;
        }
        this.classRosterService.edit(this.programId, this.classId, (response && response.id) ? "update" : "insert", "facilitationResponse");
        this.classRosterService.update(facilitationResponse);
        this.classRosterService.save().pipe(take(1)).subscribe(() => {
            this.getRosterFacilitators();
        });
        this.toggleRow(null, 'facilitator');
        this.getRosterFacilitators();
    }

    /**
     * When opening a time picker for a new slot (`timeMissed` null), the service payload is reset.
     * If the user already chose one side (e.g. end first), that value lives on the row / nested miss
     * but would be wiped — merge it back so validation and save stay in sync with the UI.
     * Uses the same rules as {@link pickerValueForNewWithNestedSlot} / {@link pickerValueForNewTimeRow}.
     */
    private rosterPayloadTimeFromPickerSeed(seed: string): string {
        return seed && seed.length > 0 ? seed : 'Add Time';
    }

    /**
     * Start-time seed for a new row: prefer flat `checkInTime`, then nested. Empty string = unset.
     * Shared by picker display and {@link togglePicker} service payload merge.
     */
    private pickerSeedForAddCheckIn(
        flat: { checkInTime?: string } | undefined,
        nested: { checkInTime?: string } | undefined
    ): string {
        const t = flat?.checkInTime;
        if (t && t !== 'Add Time' && t !== 'Invalid date') {
            return t;
        }
        const nt = nested?.checkInTime;
        return nt && nt !== 'Add Time' && nt !== 'Invalid date' ? nt : '';
    }

    /**
     * End-time seed for a new row: same rules as the time-picker binding (including suppressing
     * nested end when it still equals start on an otherwise empty flat end).
     */
    private pickerSeedForAddCheckOut(
        flat: { checkInTime?: string; checkOutTime?: string } | undefined,
        nested: { checkInTime?: string; checkOutTime?: string } | undefined
    ): string {
        const t = flat?.checkOutTime;
        if (t && t !== 'Add Time' && t !== 'Invalid date') {
            return t;
        }
        const nt = nested?.checkOutTime;
        const ni = nested?.checkInTime;
        if (!nt || nt === 'Add Time' || nt === 'Invalid date') {
            return '';
        }
        if (
            (flat?.checkOutTime === undefined || flat?.checkOutTime === 'Add Time') &&
            ni &&
            nt === ni
        ) {
            return '';
        }
        return nt;
    }

    togglePicker(participantId?, timeMissed = null, type = null, target = null) {
        /* Only clear when opening a field; bare togglePicker() closes picker after update() and must keep range errors. */
        if (type) {
            this.setTimeRangeInlineError(null);
        }
        this.listText = '';
        this.selectedPickerId = (timeMissed) ? timeMissed.id : 0;
        this.selectedType = type;
        this.selectedTarget = target;
        if (this.selectedTarget === 'participant' && participantId) {
            this.participantSelectedIndex = this.participants.findIndex((val: any) => val.participantId === participantId);
            this.addedParticipantsInfo[this.participantSelectedIndex].selectedType = type;
            this.addedParticipantsInfo[this.participantSelectedIndex].selectedTarget = target;
        } else if (participantId) {
            this.selectedIndex = this.facilitators.findIndex((val: any) => val.participantId === participantId);
            this.addedFacilitatorsInfo[this.selectedIndex].selectedType = type;
            this.addedFacilitatorsInfo[this.selectedIndex].selectedTarget = target;
            this.enableFacilitatorSaveCta();
        }
        let copy: any;
        if (type) {
            switch (this.selectedTarget) {
                case "facilitation": {
                    const flatFac = this.addedFacilitation[this.selectedIndex];
                    const nestedFac = this.addedFacilitatorsInfo[this.selectedIndex]?.facilitation
                        ?.facilitationTime?.[0];
                    const facilitation = timeMissed ?? {
                        checkInTime: this.rosterPayloadTimeFromPickerSeed(
                            this.pickerSeedForAddCheckIn(flatFac, nestedFac)
                        ),
                        checkOutTime: this.rosterPayloadTimeFromPickerSeed(
                            this.pickerSeedForAddCheckOut(flatFac, nestedFac)
                        ),
                        checkInBy: this.facilitatorIndex >= 0 ? "Facilitator" : 'Admin',
                        createdBy: this.email
                    };
                    copy = {
                        participantId: participantId,
                        facilitationTime: [facilitation]
                    };
                    this.classRosterService.edit(this.programId, this.classId, (timeMissed) ? "update" : "insert", target, copy);
                    this.classRosterService.update(copy);
                    break;
                }
                case "participation": {
                    const flatPt = this.addedParticipation[this.selectedIndex];
                    const nestedPt = this.addedFacilitatorsInfo[this.selectedIndex]?.participation
                        ?.participationTime?.[0];
                    const participation = timeMissed ?? {
                        checkInTime: this.rosterPayloadTimeFromPickerSeed(
                            this.pickerSeedForAddCheckIn(flatPt, nestedPt)
                        ),
                        checkOutTime: this.rosterPayloadTimeFromPickerSeed(
                            this.pickerSeedForAddCheckOut(flatPt, nestedPt)
                        ),
                        checkInBy: this.facilitatorIndex >= 0 ? "Facilitator" : 'Admin',
                        createdBy: this.email
                    };
                    copy = {
                        participantId: participantId,
                        participationTime: [participation]
                    };
                    this.classRosterService.edit(this.programId, this.classId, (timeMissed) ? "update" : "insert", target, copy);
                    this.classRosterService.update(copy);
                    break;
                }
                default: {
                    const rowForMiss =
                        this.selectedTarget === 'participant'
                            ? this.addedParticipantsInfo?.[this.participantSelectedIndex]
                            : this.addedFacilitatorsInfo?.[this.selectedIndex];
                    const nestedMiss = rowForMiss?.miss?.totalMissed?.[0];
                    const miss = timeMissed ?? {
                        classDate: moment(this.classDate).format('YYYY-MM-DD'),
                        checkInTime: this.rosterPayloadTimeFromPickerSeed(
                            this.pickerSeedForAddCheckIn(rowForMiss, nestedMiss)
                        ),
                        checkOutTime: this.rosterPayloadTimeFromPickerSeed(
                            this.pickerSeedForAddCheckOut(rowForMiss, nestedMiss)
                        ),
                        checkInBy: this.facilitatorIndex >= 0 ? "Facilitator" : 'Admin',
                        createdBy: this.email
                    };
                    copy = {
                        participantId: participantId,
                        totalMissed: [miss]
                    };
                    this.classRosterService.edit(this.programId, this.classId, (timeMissed) ? "update" : "insert", target, copy);
                    this.classRosterService.update(copy);
                }
            }
        }
    }

    protected enableFacilitatorSaveCta(): void {
        const row = this.addedFacilitatorsInfo[this.selectedIndex];
        if (!row) {
            return;
        }
        let facilitationTimeEnableCta = false;
        let participationTimeEnableCta = false;
        if (row.facilitation) {
            const facilitationTime = row.facilitation?.facilitationTime?.[0];
            facilitationTimeEnableCta = hasCompleteTimePair(
                facilitationTime?.checkInTime,
                facilitationTime?.checkOutTime
            );
        } else {
            facilitationTimeEnableCta = hasCompleteTimePair(row.checkInTime, row.checkOutTime);
        }
        if (row.participation) {
            const participationTime = row.participation?.participationTime?.[0];
            participationTimeEnableCta = hasCompleteTimePair(
                participationTime?.checkInTime,
                participationTime?.checkOutTime
            );
        } else {
            participationTimeEnableCta = hasCompleteTimePair(row.checkInTime, row.checkOutTime);
        }

        const missFirst = row.miss?.totalMissed?.[0];
        const facilitatorMissSlotComplete =
            !!missFirst && hasCompleteTimePair(missFirst.checkInTime, missFirst.checkOutTime);

        const flatMissNewRowComplete = hasCompleteTimePair(row.checkInTime, row.checkOutTime);

        row.enableSaveCta =
            facilitationTimeEnableCta ||
            participationTimeEnableCta ||
            facilitatorMissSlotComplete ||
            flatMissNewRowComplete;
    }

    update($event) {
        this.isShowSave = true;
        this.setTimeRangeInlineError(null);
        switch (this.selectedTarget) {
            case "facilitation":
                this.showReason = false;
                let facilitation = this.classRosterService.update();
                if (facilitation?.facilitationTime[0].id) {
                    if (!this.updatedDetails.preCheckInTime) this.updatedDetails.preCheckInTime = this.formatTime(facilitation.facilitationTime[0].checkInTime);
                    if (!this.updatedDetails.preCheckOutTime) this.updatedDetails.preCheckOutTime = this.formatTime(facilitation.facilitationTime[0].checkOutTime);
                    if (this.selectedType == "checkIn") {
                        this.updatedDetails.id = facilitation.facilitationTime[0].id;
                        this.updatedDetails.checkInTime = this.formatTime($event.value);
                        this.updatedDetails.checkOutTime = this.formatTime(facilitation.facilitationTime[0].checkOutTime);
                        facilitation.facilitationTime[0].checkInTime = this.formatTime($event.value);
                        facilitation.facilitationTime[0].checkOutTime = this.formatTime(facilitation.facilitationTime[0].checkOutTime);
                    } else if (this.selectedType == "checkOut") {
                        this.updatedDetails.id = facilitation.facilitationTime[0].id;
                        this.updatedDetails.checkOutTime = this.formatTime($event.value);
                        this.updatedDetails.checkInTime = this.formatTime(facilitation.facilitationTime[0].checkInTime);
                        facilitation.facilitationTime[0].checkOutTime = this.formatTime($event.value);
                        facilitation.facilitationTime[0].checkInTime = this.formatTime(facilitation.facilitationTime[0].checkInTime);
                    }
                    facilitation.facilitationTime[0].createdBy = this.email;
                    this.updateSaveBarEditList();
                } else {
                    this.isAdded = true;
                    if (this.selectedType == "addCheckIn") {
                        this.newAddedDetails.checkInTime = this.formatTime($event.value);
                        this.addedFacilitation[this.selectedIndex].checkInTime = this.formatTime($event.value);
                        facilitation.facilitationTime[0].checkInTime = this.formatTime($event.value);
                    } else if (this.selectedType == "addCheckOut") {
                        this.newAddedDetails.checkOutTime = this.formatTime($event.value);
                        this.addedFacilitation[this.selectedIndex].checkOutTime = this.formatTime($event.value);
                        facilitation.facilitationTime[0].checkOutTime = this.formatTime($event.value);
                        facilitation.facilitationTime[0].checkInTime = this.newAddedDetails.checkInTime;
                    }
                }
                this.classRosterService.update(facilitation);
                this.addedFacilitatorsInfo[this.selectedIndex].facilitation = facilitation;
                this.enableFacilitatorSaveCta();
                this.setTimeRangeInlineError(
                    getTimeRangeValidationWithCompleteness(
                        facilitation?.facilitationTime?.[0]?.checkInTime,
                        facilitation?.facilitationTime?.[0]?.checkOutTime
                    )
                );
                break;
            case "participation":
                this.showReason = false;
                let participation = this.classRosterService.update();
                if (participation.participationTime[0].id) {
                    if (!this.updatedDetails.preCheckInTime) this.updatedDetails.preCheckInTime = this.formatTime(participation.participationTime[0].checkInTime);
                    if (!this.updatedDetails.preCheckOutTime) this.updatedDetails.preCheckOutTime = this.formatTime(participation.participationTime[0].checkOutTime);
                    if (this.selectedType == "checkIn") {
                        this.updatedDetails.id = participation.participationTime[0].id;
                        this.updatedDetails.checkInTime = this.formatTime($event.value);
                        this.updatedDetails.checkOutTime = this.formatTime(participation.participationTime[0].checkOutTime);
                        participation.participationTime[0].checkInTime = this.formatTime($event.value);
                        participation.participationTime[0].checkOutTime = this.formatTime(participation.participationTime[0].checkOutTime);
                    } else if (this.selectedType == "checkOut") {
                        this.updatedDetails.id = participation.participationTime[0].id;
                        this.updatedDetails.checkOutTime = this.formatTime($event.value);
                        this.updatedDetails.checkInTime = this.formatTime(participation.participationTime[0].checkInTime);
                        participation.participationTime[0].checkOutTime = this.formatTime($event.value);
                        participation.participationTime[0].checkInTime = this.formatTime(participation.participationTime[0].checkInTime);
                    }
                    participation.participationTime[0].createdBy = this.email;
                    this.updateSaveBarEditList();
                } else {
                    this.isAdded = true;
                    if (this.selectedType == "addCheckIn") {
                        this.newAddedDetails.checkInTime = this.formatTime($event.value);
                        this.addedParticipation[this.selectedIndex].checkInTime = this.formatTime($event.value);
                        participation.participationTime[0].checkInTime = this.formatTime($event.value);
                    } else if (this.selectedType == "addCheckOut") {
                        this.newAddedDetails.checkOutTime = this.formatTime($event.value);
                        this.addedParticipation[this.selectedIndex].checkOutTime = this.formatTime($event.value);
                        participation.participationTime[0].checkOutTime = this.formatTime($event.value);
                        participation.participationTime[0].checkInTime = this.newAddedDetails.checkInTime;
                    }
                }
                this.classRosterService.update(participation);
                this.addedFacilitatorsInfo[this.selectedIndex].participation = participation;
                this.enableFacilitatorSaveCta();
                this.setTimeRangeInlineError(
                    getTimeRangeValidationWithCompleteness(
                        participation?.participationTime?.[0]?.checkInTime,
                        participation?.participationTime?.[0]?.checkOutTime
                    )
                );
                break;
            default:
                this.showReason = true;
                let miss = this.classRosterService.update();
                if (miss.totalMissed[0].id) {
                    if (!this.updatedDetails.preCheckInTime) this.updatedDetails.preCheckInTime = this.formatTime(miss.totalMissed[0].checkInTime);
                    if (!this.updatedDetails.preCheckOutTime) this.updatedDetails.preCheckOutTime = this.formatTime(miss.totalMissed[0].checkOutTime);
                    if (this.selectedType == "checkIn") {

                        this.updatedDetails.id = miss.totalMissed[0].id;
                        this.updatedDetails.checkInTime = this.formatTime($event.value);
                        this.updatedDetails.checkOutTime = this.formatTime(miss.totalMissed[0].checkOutTime);
                        miss.totalMissed[0].checkInTime = this.formatTime($event.value);
                        miss.totalMissed[0].checkOutTime = this.formatTime(miss.totalMissed[0].checkOutTime);


                    } else if (this.selectedType == "checkOut") {
                        this.updatedDetails.id = miss.totalMissed[0].id;
                        this.updatedDetails.checkOutTime = this.formatTime($event.value);
                        this.updatedDetails.checkInTime = this.formatTime(miss.totalMissed[0].checkInTime);
                        miss.totalMissed[0].checkOutTime = this.formatTime($event.value);
                        miss.totalMissed[0].checkInTime = this.formatTime(miss.totalMissed[0].checkInTime);

                    }
                    miss.totalMissed[0].createdBy = this.email;
                    this.updateSaveBarEditList();
                    if (this.selectedTarget === 'facilitator') {
                        this.addedFacilitatorsInfo[this.selectedIndex].miss = JSON.parse(JSON.stringify(miss));
                    } else {
                        this.addedParticipantsInfo[this.participantSelectedIndex].miss = JSON.parse(JSON.stringify(miss));
                    }
                    this.setTimeRangeInlineError(
                        getTimeRangeValidationWithCompleteness(
                            miss.totalMissed[0].checkInTime,
                            miss.totalMissed[0].checkOutTime
                        )
                    );
                } else {
                    this.isAdded = true;
                    if (this.selectedType == "addCheckIn") {
                        this.newAddedDetails.checkInTime = this.formatTime($event.value);
                        if (this.selectedTarget === 'facilitator') {
                            this.addedFacilitatorsInfo[this.selectedIndex].checkInTime = this.formatTime($event.value);
                        } else {
                            this.addedParticipantsInfo[this.participantSelectedIndex].checkInTime = this.formatTime($event.value);
                        }
                        miss.totalMissed[0].checkInTime = this.formatTime($event.value);
                    } else if (this.selectedType == "addCheckOut") {
                        this.newAddedDetails.checkOutTime = this.formatTime($event.value);
                        if (this.selectedTarget === 'facilitator') {
                            this.addedFacilitatorsInfo[this.selectedIndex].checkOutTime = this.formatTime($event.value);
                        } else {
                            this.addedParticipantsInfo[this.participantSelectedIndex].checkOutTime = this.formatTime($event.value);
                        }
                        miss.totalMissed[0].checkOutTime = this.formatTime($event.value);
                        if (this.newAddedDetails.checkInTime !== undefined && this.newAddedDetails.checkInTime !== null) {
                            miss.totalMissed[0].checkInTime = this.newAddedDetails.checkInTime;
                        }

                    }
                    if (this.selectedTarget === 'facilitator') {
                        this.addedFacilitatorsInfo[this.selectedIndex].miss = JSON.parse(JSON.stringify(miss));
                    } else {
                        this.addedParticipantsInfo[this.participantSelectedIndex].miss = JSON.parse(JSON.stringify(miss));
                    }

                    if (miss.totalMissed[0].checkInTime == "Invalid date"
                        || miss.totalMissed[0].checkOutTime == "Invalid date") {

                        this.resetFields();
                        this.snackBar.open('Invalid Time Missed Input.', 'OK', {
                            duration: 8000,
                            horizontalPosition: this.horizontalPosition,
                            verticalPosition: this.verticalPosition,
                            panelClass: ['error-snackbar']
                        });
                    }
                    else {
                        this.setTimeRangeInlineError(
                            getTimeRangeValidationWithCompleteness(
                                miss.totalMissed[0].checkInTime,
                                miss.totalMissed[0].checkOutTime
                            )
                        );
                        this.classRosterService.update(miss);
                    }
                }
                if (this.selectedTarget === 'facilitator') {
                    this.enableFacilitatorSaveCta();
                } else if (this.selectedTarget === 'participant') {
                    this.enableParticipantSaveCta();
                }
        }

        this.togglePicker();
    }

    /**
     * Participant save-bar visibility uses enableSaveCta on the row; keep it in sync with
     * time missed on addedParticipantsInfo (flat add row and/or miss.totalMissed[0]).
     */
    protected enableParticipantSaveCta(): void {
        const idx = this.participantSelectedIndex;
        if (idx == null || idx < 0 || !this.addedParticipantsInfo?.[idx]) {
            return;
        }
        const row = this.addedParticipantsInfo[idx];
        const missFirst = row.miss?.totalMissed?.[0];
        const missSlotComplete =
            !!missFirst && hasCompleteTimePair(missFirst.checkInTime, missFirst.checkOutTime);
        const flatMissNewRowComplete = hasCompleteTimePair(row.checkInTime, row.checkOutTime);
        row.enableSaveCta = missSlotComplete || flatMissNewRowComplete;
    }

    /**
     * Sets inline time-order validation message and which roster row it belongs to
     * (so multiple expanded rows do not all show the same error).
     */
    protected setTimeRangeInlineError(message: string | null): void {
        this.timeRangeInlineError = message;
        if (!message) {
            this.timeRangeErrorFacilitatorRow = null;
            this.timeRangeErrorParticipantRow = null;
            return;
        }
        switch (this.selectedTarget) {
            case 'participant':
                this.timeRangeErrorParticipantRow = this.participantSelectedIndex;
                this.timeRangeErrorFacilitatorRow = null;
                break;
            case 'facilitator':
            case 'facilitation':
            case 'participation':
                this.timeRangeErrorFacilitatorRow = this.selectedIndex;
                this.timeRangeErrorParticipantRow = null;
                break;
            default:
                this.timeRangeErrorFacilitatorRow = null;
                this.timeRangeErrorParticipantRow = null;
                break;
        }
    }

    /** Pass to facilitator save-bar at index `i`. */
    rangeErrorForFacilitatorSaveBar(i: number): string | null {
        return this.timeRangeErrorFacilitatorRow === i ? this.timeRangeInlineError : null;
    }

    /** Pass to participant save-bar at index `i`. */
    rangeErrorForParticipantSaveBar(i: number): string | null {
        return this.timeRangeErrorParticipantRow === i ? this.timeRangeInlineError : null;
    }

    delete(pid, time, target, index) {
        switch (target) {
            case "facilitation":
                this.missedInfo.id = time.id;
                this.missedInfo.checkInBy = time.checkInBy;
                this.missedInfo.createdBy = this.email;
                this.arrMissedInfo.push(this.missedInfo);
                this.deletedInfo.participantId = pid;
                this.deletedInfo.facilitationTime = this.arrMissedInfo;
                this.classRosterService.edit(this.programId, this.classId, "delete", "facilitation");
                this.classRosterService.update(this.deletedInfo);
                this.addedFacilitatorsInfo[index].enableSaveCta = true;
                this.facilitationSelectedIndex = index;
                this.setSaveBarValues(time);
                break;
            case "participation":
                this.missedInfo.id = time.id;
                this.missedInfo.checkInBy = time.checkInBy;
                this.missedInfo.createdBy = this.email;
                this.arrMissedInfo.push(this.missedInfo);
                this.deletedInfo.participantId = pid;
                this.deletedInfo.participationTime = this.arrMissedInfo;
                this.classRosterService.edit(this.programId, this.classId, "delete", "participation");
                this.classRosterService.update(this.deletedInfo);
                this.addedFacilitatorsInfo[index].enableSaveCta = true;
                this.participatiopnSelectedIndex = index;
                this.setSaveBarValues(time);
                break;
            default:
                this.missedInfo.id = time.id;
                this.missedInfo.checkInBy = time.checkInBy;
                this.missedInfo.comments = time.comments;
                this.missedInfo.createdBy = this.email;
                this.arrMissedInfo.push(this.missedInfo);
                this.deletedInfo.participantId = pid;
                this.deletedInfo.totalMissed = this.arrMissedInfo;
                this.classRosterService.edit(this.programId, this.classId, "delete", "participant");
                this.classRosterService.update(this.deletedInfo);
                if (target === 'facilitators') {
                    this.selectedIndex = index;
                    this.addedFacilitatorsInfo[index].enableSaveCta = true;
                } else if (target === 'participants') {
                    this.addedParticipantsInfo[index].enableSaveCta = true;
                    this.participantSelectedIndex = index;
                }
                this.setSaveBarValues(time);
        }
        if (target === 'facilitators') {
            this.selectedIndex = index;
            this.addedFacilitatorsInfo[index].enableSaveCta = true;
        } else if (target === 'participants') {
            this.addedParticipantsInfo[index].enableSaveCta = true;
            this.participantSelectedIndex = index;
        }
    }

    confirm() {
        this.doConfirm = true;
    }

    saveConfirm() {
        this.doConfirm = false;
        this.classRosterService
            .postConfirmation(
                {
                    facilitatorId: this.email,
                    confirmed: true,
                    role: 'facilitator'
                } as IConfirmation,
                this.programId, this.classId
            )
            .pipe(take(1))
            .subscribe(() => {
                this.getConfirmation(this.programId, this.classId);
                this.isConfirmed = true;
            },
                () => {
                    this.snackBar.open('Failed to save confirmation of the attendance. Please try again.', 'OK', {
                        duration: 8000,
                        horizontalPosition: this.horizontalPosition,
                        verticalPosition: this.verticalPosition,
                        panelClass: ['error-snackbar']
                    });
                });
    }

    cancelConfirm() {
        this.doConfirm = false;
    }

    public updateCommentFacilitator($event): void {
        if ($event?.type === 'facilitator') {
            this.addedFacilitatorsInfo[this.selectedIndex].miss.totalMissed[0].comments = $event.comments;
        } else {
            this.addedParticipantsInfo[this.participantSelectedIndex].miss.totalMissed[0].comments = $event.comments;
        }
    }

    download(type) {
        switch (type) {
            case 'wellbeing':
                this.reportService.getWellbeingCheckReport(this.programId, this.classId, this.reportName + '_Wellbeing');
                break;
            case 'participants':
                this.reportService.geParticipantCheckReport(this.programId, this.classId, this.reportName + '_Attendance');
                break;
        }
    }

    openReport() {
        this.showReport = !this.showReport;
    }

    cancelWidgetConfirm() {
        this.cancelModel = !this.cancelModel;
        this.prepareAddFacilitatorsInfo(this.facilitators);
        this.prepareAddParticipantsInfo(this.participants);
        this.toggleRow(null, this.cancelType);
    }

    keepCancelWidgetEditing(type) {
        this.participants = JSON.parse(JSON.stringify(this._participants));
        this.facilitators = JSON.parse(JSON.stringify(this._facilitators));
        this.cancelType = type;
        this.cancelModel = !this.cancelModel;
    }

    getConfirmation(programId, classId) {
        this.confirmationDataErrorMessage = {};
        this.classRosterService.getConfirmation(programId, classId).pipe(
            takeUntil(this.destroy$),
            map(data => data))
            .subscribe((response: IConfirmation) => {
                this.confirmationDataErrorMessage.text = response ? '' : API_USER_DEFINED_MESSAGE.EMPTY_RESPONSE;
                this.confirmationData = response;
                this.isConfirmed = response.confirmed;
                this.classStatus = response.classStatus;
                this.getNotifications();
            },
                () => {
                    this.confirmationData = [];
                    this.confirmationDataErrorMessage.text = API_USER_DEFINED_MESSAGE.FAILED;
                });
    }

    getRosterFacilitators(initialCall?) {
        this.facilitatorsErrorMessage = {};
        this.programService.getRosterFacilitators(this.programId, this.classId).pipe(
            takeUntil(this.destroy$),
            map(data => data))
            .subscribe((response) => {
                this.facilitatorsErrorMessage.text = response?.length ? '' : API_USER_DEFINED_MESSAGE.EMPTY_RESPONSE;
                const currentInfo = JSON.parse(JSON.stringify(this.facilitators || []));
                response.map(x => x.fullName = x?.lastName + ', ' + x?.firstName);
                this.facilitators = response;
                this._facilitators = JSON.parse(JSON.stringify(this.facilitators));
                this.prepareAddFacilitatorsInfo(currentInfo);
                if (initialCall) {
                    this.facilitatorIndex = response.findIndex(y => y?.email?.toLowerCase() === this.email?.toLowerCase());
                }
            },
                () => {
                    this.facilitators = [];
                    this._facilitators = JSON.parse(JSON.stringify(this.facilitators));
                    this.facilitatorsErrorMessage.text = API_USER_DEFINED_MESSAGE.FAILED;
                });
    }

    getRosterParticipants() {
        this.participantsErrorMessage = {};
        this.programService.getRosterParticipants(this.programId, this.classId).pipe(
            takeUntil(this.destroy$),
            map(data => data))
            .subscribe((response: IParticipants[]) => {
                this.participantsErrorMessage.text = response?.length ? '' : API_USER_DEFINED_MESSAGE.EMPTY_RESPONSE;
                const currentInfo = JSON.parse(JSON.stringify(this.participants || []));
                response.map(x => x.fullName = x?.lastName + ', ' + x?.firstName);
                this.participants = response;
                this._participants = JSON.parse(JSON.stringify(this.participants));
                this.prepareAddParticipantsInfo(currentInfo);
            },
                () => {
                    this.participants = [];
                    this._participants = JSON.parse(JSON.stringify(this.participants));
                    this.participantsErrorMessage.text = API_USER_DEFINED_MESSAGE.FAILED;
                });
    }

    protected prepareAddParticipantsInfo(currentInfo: IParticipants[]): void {
        this.addedParticipantsInfo = [];
        this.updatedDetailCache = [];
        this.updatedDetails = <IMissedPrePostInfo>{};
        const checkInOut = {
            checkInTime: "Add Time",
            checkOutTime: 'Add Time'
        };
        const expandedById = new Map<string | number, boolean>();
        (currentInfo || []).forEach((row: any) => {
            const id = row?.participantId ?? row?.id;
            if (id != null && row?.isEdit) {
                expandedById.set(id, true);
            }
        });
        this.participants.forEach((participant: IParticipants) => {
            const p: any = participant;
            const id = p?.participantId ?? p?.id;
            p.isEdit = id != null && expandedById.has(id);
            this.addedParticipantsInfo.push(<IMissedInfo>JSON.parse(JSON.stringify(checkInOut)));
        });
    }

    protected prepareAddFacilitatorsInfo(currentInfo: IFacilitators[]): void {
        this.addedFacilitatorsInfo = [];
        this.addedParticipation = [];
        this.addedFacilitation = [];
        this.updatedDetailCache = [];
        this.updatedDetails = <IMissedPrePostInfo>{};
        const checkInOut = {
            checkInTime: "Add Time",
            checkOutTime: 'Add Time'
        };
        const expandedById = new Map<string | number, boolean>();
        (currentInfo || []).forEach((row: any) => {
            const id = row?.participantId ?? row?.id;
            if (id != null && row?.isEdit) {
                expandedById.set(id, true);
            }
        });
        this.facilitators.forEach((facilitator: IFacilitators) => {
            const f: any = facilitator;
            const id = f?.participantId ?? f?.id;
            f.isEdit = id != null && expandedById.has(id);
            this.addedFacilitatorsInfo.push(<IMissedInfo>JSON.parse(JSON.stringify(checkInOut)));
            this.addedParticipation.push(<IMissedInfo>JSON.parse(JSON.stringify(checkInOut)));
            this.addedFacilitation.push(<IMissedInfo>JSON.parse(JSON.stringify(checkInOut)));
        });
    }

    protected updateSaveBarEditList() {
        this.updatedDetailCache = this.updatedDetailCache.filter(x => x.id != this.updatedDetails.id);
        this.updatedDetailCache.push(this.updatedDetails);
        // this.getRosterParticipants();
    }

    /** For new check-in/out rows (`selectedPickerId === 0`), seed time-picker from current row values. */
    public pickerValueForNewFacilitationTime(rowIndex: number): string {
        return this.pickerValueForNewWithNestedSlot(
            this.selectedType,
            this.addedFacilitation[rowIndex],
            this.addedFacilitatorsInfo[rowIndex]?.facilitation?.facilitationTime?.[0]
        );
    }

    public pickerValueForNewParticipationTime(rowIndex: number): string {
        return this.pickerValueForNewWithNestedSlot(
            this.selectedType,
            this.addedParticipation[rowIndex],
            this.addedFacilitatorsInfo[rowIndex]?.participation?.participationTime?.[0]
        );
    }

    public pickerValueForNewFacilitatorMissTime(rowIndex: number): string {
        return this.pickerValueForNewTimeRow(this.selectedType, this.addedFacilitatorsInfo[rowIndex]);
    }

    public pickerValueForNewParticipantMissTime(rowIndex: number): string {
        return this.pickerValueForNewTimeRow(this.selectedType, this.addedParticipantsInfo[rowIndex]);
    }

    private pickerValueForNewWithNestedSlot(
        selectedType: string,
        flat: { checkInTime?: string; checkOutTime?: string } | undefined,
        nested: { checkInTime?: string; checkOutTime?: string } | undefined
    ): string {
        if (!flat && !nested) {
            return '';
        }
        if (selectedType === 'addCheckIn') {
            return this.pickerSeedForAddCheckIn(flat, nested);
        }
        if (selectedType === 'addCheckOut') {
            return this.pickerSeedForAddCheckOut(flat, nested);
        }
        return '';
    }

    private pickerValueForNewTimeRow(
        selectedType: string,
        row:
            | {
                  checkInTime?: string;
                  checkOutTime?: string;
                  miss?: { totalMissed?: Array<{ checkInTime?: string; checkOutTime?: string }> };
              }
            | undefined
    ): string {
        if (!row) {
            return '';
        }
        const missed = row.miss?.totalMissed?.[0];
        if (selectedType === 'addCheckIn') {
            return this.pickerSeedForAddCheckIn(row, missed);
        }
        if (selectedType === 'addCheckOut') {
            return this.pickerSeedForAddCheckOut(row, missed);
        }
        return '';
    }

    protected formatTime(time) {
        return moment.utc(time, ['h:mm A']).format('HH:mm:ss');
    }

    protected setSaveBarValues(timeMissed) {
        this.isShowSave = true;
        this.isAdded = true;
        this.isDeleted = true;
        this.listText = 'Save changes to delete time missed';
        this.newAddedDetails = {} as IMissedInfo;
        this.newAddedDetails.checkInTime = timeMissed.checkInTime;
        this.newAddedDetails.checkOutTime = timeMissed.checkOutTime;
    }

    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.complete();
    }

    totalTimeMissed(totalMissed) {
        let total = 0;
        totalMissed?.forEach((element) => {
            total = total + this.timeDiff.transform(element?.checkInTime, element?.checkOutTime);
        });
        return total;
    }
}
